import { ResultType } from './types';

export function getTextCategoryByType(type: ResultType) {
  switch (type) {
    case ResultType.Rephrase: {
      return 'rephrase';
    }

    case ResultType.Common:
    case ResultType.Recent: {
      return 'text';
    }
  }
}
